export const dataMassage = [
  {
    id: "0",
    title: "MASSAGE DES 5 CONTINENTS®",
    img_main: "m5c-main.jpg",
    img_illustration: [
      "m5c-main.jpg",
      "m5c_slider.jpg",
      "m5c-ill1.jpg",
      "m5c-ill2.jpg",
      "m5c-ill3.jpg",
    ],
    large_description: `Le M5C est un massage du corps offrant un <b>lâcher prise physique et mental</b> absolument inédit en reprenant de célèbres techniques du monde.
        <br />
        <br />
        Il regroupe ainsi <b>le massage, l’aromathérapie et l’énergie du magnétisme</b> pour en faire une expérience unique. 
        <br />
        <br />
        Le M5C nous plonge dans l’Asie avec le <b>Shiatsu</b> et le <b>Tuina</b>, qui à travers des méridiens énergétiques rendent le corps plus équilibré.<br />
        Continuant avec les techniques du <b>Lomi-Lomi</b> hawaïen qui inondent le corps d’un profond bien-être.<br />
        En passant par le massage turc, qui a une action à la fois dynamique et relaxante.<br />
        Les touches <b>Ayurvédiques</b> et la traversée des Chakras nous transportent en Inde.<br />
        Et enfin, les techniques du massage <b>suédois</b> qui détendent les muscles tant sollicités.<br />
        <br />
        Ce soin se pratique avec une <b>synergie d’huiles végétales et d’huiles essentielles</b> pour vous transporter vers un voyage hors du temps.
        <br />
        <br />
        <b>‍Détoxification, Revitalisation, Reconnexion</b> sont les maîtres mots de ce massage exceptionnel.`,
    tarif: `Tarif = <b>85€ (1H15)</b>`,
  },
  {
    id: "1",
    title: "MASSAGE DU VISAGE SKINTAO EXCELLENCE®",
    img_main: "skintao-main.jpg",
    img_illustration: [
      "skintao-main.jpg",
      "skintao_slider.jpg",
      "skintao-ill1.jpg",
      "skintao-ill2.jpg",
      "skintao-ill3.jpg",
    ],
    large_description: ` <b>Le Skintao est au visage ce que le fitness est au corps : remodelant, raffermissant et entretenant.</b>
        <br />
        <br />
        Le massage facial Skintao ® agit comme un véritable soin anti-âge de par ses multiples manœuvres telles que les percussions, les enveloppements, les pressions et les effleurages. La micro-circulation est relancée offrant une meilleure oxygénation et un apport en nutriments essentiels aux cellules.
        <br />
        <br />
        C'est un savoir-faire inspiré de la culture japonaise qui permet de tonifier et de repulper l'ensemble du visage de façon à atténuer les rides, à procurer un effet liftant et à favoriser un joli teint naturel.
        <br />
        <br />
       ‍<b>Le teint en ressort lumineux et la peau repulpée.</b>
        <br />
        <br />
       J’intègre au cours du massage différents outils : Gua Sha en jade blanc qui permet d’améliorer l’élasticité de la peau, Gua Sha en obsidienne noire connue pour apaiser les peaux tiraillées ainsi que des ventouses pour redéfinir les contours du visage et détendre les muscles.
         <br />
        <br />
        Pratiqué de manière régulière, ce massage retarde les signes du vieillissement et offre un effet liftant dans la durée. Il est recommandé de pratiquer les premières séances rapprochées en cure « BOOST » (deux fois par semaine pendant un mois) afin que la mémoire du visage s’active, puis une séance par mois pour entretenir les bienfaits du massage.
        `,
    tarif: `Ce massage se pratique à la carte ou en cure : Tarif = <b>70€ (1H)</b> et cure BOOST <b>35€ (30 min)</b>`,
  },
  {
    id: "2",
    title: "BELLY REVOLUTION ®",
    img_main: "Belly-main.png",
    img_illustration: [
      "belly_slider.jpg",
      "belly-ill1.jpg",
      "belly-ill2.jpg",
      "belly-ill3.jpg",
    ],
    large_description: `Le Belly Revolution ® est un massage du ventre qui permet de <b>relâcher les tensions</b> du corps grâce à des techniques de <b>drainage, modelage, effleurage et à un procédé énergétique.</b>
        <br />
        <br />
        Quel rapport entre le ventre et les émotions ?
        <br />
        <br />
        Le ventre appelé aussi « le deuxième cerveau » compte 500 millions de neurones. Il échange de manière continue avec le système nerveux pour transmettre les informations grâce au nerf vague.<br />
        <b>Notre ventre reflète ainsi notre état émotionnel</b> qui a un impact indiscutable sur notre santé de manière holistique.
        <br />
        <br />
        Quels sont les autres bienfaits du Belly Revolution ® ?
        <br />
        <br />
        Le protocole drainant permet de <b>remettre en marche le système d'élimination du corps.</b> L'effet drainant est parfois immédiat et permet d'<b>affiner la silhouette</b> en facilitant l'<b>évacuation de l'eau et des toxines</b>, responsables de certaines douleurs (pré-menstruels, endométriose, ...) et d'inconforts digestifs (ballonnements, constipation, ...).<br />
        Toutes les manœuvres s'effectuent <b>en rythme avec votre respiration</b> ce qui vous procure une belle <b>sensation de détente et de lâcher prise.</b>
        <br />
        <br />
        Contre indications :<br />
        Fièvre et infections en cours<br />
        Antibiotiques en cours<br />
        Cancer avec traitement en cours<br />
        Femmes enceintes<br />
        Femmes en parcours PMA avec FIV<br />
        Occlusion intestinale<br />
        Intervention chirurgicale importante au niveau de l'abdomen<br />
        Anti-coagulant en cours<br />
        Greffe d'organe<br />
        Personnes mineures<br />`,
    tarif: `Ce massage se pratique à la carte ou en cure : Tarif = <b>60€ (50 min)</b><br />
        Le forfait de 3 massages : <b>160€</b>`,
  },
  {
    id: "3",
    title: "MASSAGE DRAINANT METHODE VODDER",
    img_main: "vodder-main.jpg",
    img_illustration: [
      "vodder-main.jpg",
      "vodder_slider.jpg",
      "vodder-ill1.jpg",
      "vodder-ill2.jpg",
      "vodder-ill3.jpg",
    ],
    large_description: `Qu’est-ce que la lymphe ?
        <br />
        <br />
        ‍La lymphe est un liquide corporel clair jouant un rôle essentiel dans la santé. Elle circule lentement dans notre corps via un réseau qui permet d’évacuer les déchets et d’assurer le bon fonctionnement des défenses immunitaires grâce aux ganglions lymphatiques. Dépourvu de système de pompage, le seul moyen de faire circuler la lymphe est de bouger !
        <br />
        <br />
        ‍Qu’est ce que le massage drainant?
        <br />
        <br />
        Aussi appelé drainage lymphatique ce massage bien-être permet de stimuler la circulation de la lymphe et de renforcer l’immunité par des mouvements très doux sur l’ensemble du corps à l’aide des doigts et de la paume des mains.<br />
        J'intègre au cours du soin un masque en quartz rose afin d'apaiser le mental.<br />
        Pour parfaire le soin, je vous conseille de faire un gommage du corps avec un gant de crêpe et du savon noir 1 fois par semaine.
        ‍<br />
        <br />
        
        ‍Les bienfaits apportés :
        <br />
        <br />
        Amélioration du transit <br />
        Soulagement des jambes lourdes<br />
        Réduction des oedèmes, rétention d'eau<br />
        Elimination de la cellulite aqueuse<br />
        Raffermissement de la peau <br />
        Décontraction musculaire<br />
        Favorise le sommeil réparateur<br />
        Diminution du stress …
        <br />
        <br />
        Attention, ce massage n’est pas indiqué en cas :<br />
        de cancers<br />
        d’infection aiguë<br />
        de thrombose<br />
        d’insuffisance rénale ou cardiaque<br />
        d’œdème cardiaque<br />
        d’asthme<br />
        d’hyperthyroïdie<br />
        d’hypotension artérielle<br />
        de phlébites
        ‍<br />
        <br />
        Demander conseil à votre médecin traitant avant de recevoir ce massage
        `,
    tarif: `Ce massage se pratique à la carte ou en cure : Tarif = <b>60€ (50 min)</b><br />
        Le forfait de 5 massages = <b>275€</b>`,
  },
  {
    id: "4",
    title: "MASSAGE AUX POCHONS",
    img_main: "pochons-main.jpg",
    img_illustration: [
      "pochons-main.jpg",
      "pochons_slider.jpg",
      "pochons-ill1.jpg",
      "pochons-ill2.jpg",
      "pochons-ill3.jpg",
    ],
    large_description: `MASSAGE AUX POCHONS D'HERBES AROMATIQUES
        <br />
        <br />
        Originaire d'Asie, ce soin ancestral s'effectue à l'aide de pochons remplis de plantes médicinales et aromatiques.
        <br />
        <br />
         Les pochons sont régulièrement chauffés à la vapeur pour garantir une détente musculaire optimale, un drainage des toxines efficace et un apaisement du corps et de l'esprit considérable.
        <br />
        <br /> De plus, les odeurs qui se dégagent des pochons enivrent l'espace et vous transportent loin d'ici.
        <br />
        <br /> Je vous suggère de faire un gommage du corps avant votre rendez-vous, pour permettre une meilleure pénétration des principes actifs de l'huile de sésame ainsi que des plantes.  `,
    tarif: `Tarif <b>85€</b><br /> Le forfait de 3 SOINS <b>225€</b>
        Durée 1h30`,
  },
  {
    id: "5",
    title: "MASSAGE DU DOS RELAXANT",
    img_main: "dos-relax-main.png",
    img_illustration: [
      "dos-relax-main.png",
      "dos-relax_slider.png",
      "dos-relax-ill1.png",
      "dos-relax-ill2.png",
      "dos-relax-ill3.png",
    ],
    large_description: `MASSAGE DU DOS RELAXANT
        <br />
        <br />
        Le modelage du dos est une véritable évasion sensorielle grâce aux huiles essentielles minutieusement choisies, aux pierres volcaniques chaudes qui calment les tensions musculaires et aux gestuelles enveloppantes ciblant le dos, la nuque et le visage.
        <br />
        <br />
        Prenez le temps de choisir la combinaison parfaite des huiles essentielles que vous souhaitez recevoir en fonction de vos attentes: relaxante, détoxifiante, tonifiante ou bien décontractante.
        <br />
       `,
    tarif: `Tarifs <b>40€ (30 min) - 55€ (45 min)</b>`,
  },
];
